import { CheckIcon, DismissIcon } from "@teamscheme/icons";
import { HTMLAttributes } from "react";
import styled from "styled-components";
import { ContractType } from "../model/ContractViewModel";

enum TableRow {
  InkSign,
  BankId,
  TrialMembership,
  OwnershipTransfer,
  Storage,
  PaymentRequest,
}
const LABELS: { [row in TableRow]: string } = {
  [TableRow.InkSign]: "InkSign",
  [TableRow.BankId]: "BankID-signering",
  [TableRow.TrialMembership]: "NAF prøve\u00ADmedlem\u00ADskap",
  [TableRow.OwnershipTransfer]: "Eier\u00ADskifte hos Statens vegvesen",
  [TableRow.Storage]: "Trygg lagring",
  [TableRow.PaymentRequest]: "Betalings\u00ADoverføring med Vipps",
};
export const TYPE_NAMES: { [type in ContractType]?: string } = {
  [ContractType.Simple]: "Enkel",
  [ContractType.Standard]: "Standard",
  [ContractType.Member]: "Medlem",
  [ContractType.Premium]: "Premium",
};
type TableValue = boolean | string;

const TABLE_VALUES: {
  [type in ContractType]?: {
    [row in TableRow]: TableValue;
  };
} = {
  [ContractType.Simple]: {
    [TableRow.InkSign]: true,
    [TableRow.BankId]: false,
    [TableRow.TrialMembership]: false,
    [TableRow.OwnershipTransfer]: false,
    [TableRow.Storage]: true,
    [TableRow.PaymentRequest]: false,
  },
  [ContractType.Standard]: {
    [TableRow.InkSign]: true,
    [TableRow.BankId]: true,
    [TableRow.TrialMembership]: "1 mnd",
    [TableRow.OwnershipTransfer]: true,
    [TableRow.Storage]: true,
    [TableRow.PaymentRequest]: false,
  },
  [ContractType.Premium]: {
    [TableRow.InkSign]: true,
    [TableRow.BankId]: true,
    [TableRow.TrialMembership]: "1 mnd",
    [TableRow.OwnershipTransfer]: true,
    [TableRow.Storage]: true,
    [TableRow.PaymentRequest]: true,
  },
};

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export default styled(function ComparisonTable(
  props: Omit<HTMLAttributes<HTMLDivElement>, "children">
) {
  const keys = Object.keys(TABLE_VALUES).map((x) =>
    Number(x)
  ) as ContractType[];
  return (
    <div {...props}>
      <table>
        <thead>
          <tr>
            <th></th>
            {keys.map((key) => (
              <th key={`header-${key}`}>{TYPE_NAMES[key]}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Object.keys(LABELS)
            .map((row) => Number(row) as TableRow)
            .map((row) => (
              <tr key={`row-${row}`}>
                <th>{LABELS[row]}</th>
                {keys.map((key) => {
                  const value = TABLE_VALUES[key]![row];
                  const display =
                    typeof value === "boolean" ? (
                      <IconWrapper>
                        {value ? <CheckIcon /> : <DismissIcon />}
                      </IconWrapper>
                    ) : (
                      value
                    );
                  return <td key={`cell-${row}-${key}`}>{display}</td>;
                })}
              </tr>
            ))}
        </tbody>
      </table>
    </div>
  );
})`
  div {
    width: 100%;
  }

  table {
    width: 100%;
    margin-bottom: ${({ theme }) => theme.spacing.space16};
    border: none;
    border-spacing: 0;
  }

  tbody th {
    font-weight: normal;
  }

  th,
  td {
    padding: ${({ theme }) => theme.spacing.space16} 2px;
    border-bottom: 1px solid ${({ theme }) => theme.nafColor.neutral.neutral3};
  }

  thead th,
  td {
    text-align: center;
  }

  td {
    width: ${~~(50 / 3)}%;
  }
`;
